<script lang="ts">
  import {getContext} from 'svelte';
  import {PATHS} from '@/const/paths';
  import {mockUtil} from '@/helper/moc';
  import {fixLink$} from '@/store/lang';
  import {Button} from '@px/button';
  import Menu from '@/widgets/trigger/Menu.svelte';
  import lang from './moc.lang';
  import sLang from '@/modules/strategy/strategy-detail/strategy-detail.lang';

  export {className as class};
  export let isTop = true;

  const LG = getContext('LG');
  const placement = 'bottom-start';
  const modifiers = [
    {
      name: 'offset',
      options: {
        offset: [-24, 0],
      },
    },
    {
      name: 'preventOverflow',
      options: {
        padding: 40,
      },
    },
  ];

  const hoverBGColor = '#202429';
  const hoverColor = '#fff';
  const color = '#fff';

  let className = '';
</script>

<style>
  .mock-menu :global(.live-btn) {
    display: inline-block;
    border-radius: 20px;
    padding: 0 16px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    background-color: #0345f5;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
  }
  .mock-menu :global(.live-btn:hover) {
    opacity: 0.8;
  }
  .mock-menu {
    line-height: 56px;
  }
  .trigger {
    position: relative;
    line-height: 56px;
    padding: 0 20px;
    color: #fff;
    opacity: 1;
  }
  .top .trigger {
    color: #fff;
  }
  .title-icon {
    position: absolute;
    top: 16px;
    left: calc(100% - 2px);
    height: 14px;
  }
</style>

<nav class="mock-menu f1 df jcsb aic {className}" class:top={isTop}>
  <div class="df">
    <div class="mock-menu TW">{LG(lang.MockTrading)}</div>
    <Menu class="ml24 mr24" {placement} {modifiers} {color} {hoverColor} noIcon>
      <a class="trigger" slot="trigger" href={$fixLink$(mockUtil.getMockPrefix() + PATHS.STRATEGY_SQUARE.pathname)}>
        <span class="title">{LG(sLang.TradingBots)}</span>
        <img class="title-icon" height="14" src="//img.phemex.com/v1/54fc3980-aadf-4ed8-9873-98e199994a95/frame-14.png" alt="new" />
      </a>
    </Menu>
  </div>
  <Button type="primary" class="live-btn ml16" on:click={() => mockUtil.gotoLive()}>{LG(lang.BackToLive)}</Button>
</nav>
